export default __webpack_public_path__ + "static/media/avatar.169ceb4d.png";